// this will be a signal in the future
export const getBaseRidgeColor = () => 0xE5972A